import { Lieu } from "./lieu.model";
import { Media } from "./media.model";
import { Theme } from "./theme.model";

export class Evenement {

    documentId: string;
    titre: string;
    descriptionCourte: string;
    descriptionLongue: string;
    startDate: Date;
    endDate: Date;
    // ageMin: number;
    // ageMax: number;
    participantsMin: number;
    participantsMax: number;
    participants: number = 0;
    gallery: Media[] = [];
    themes: Theme[] = [];
    couleur: string = '#ff00c3ff';
    lieu: Lieu | undefined;

    constructor(apiEvenementResponse: any) {

        console.log('Mapping API Evenement Response:', apiEvenementResponse);

        this.documentId = apiEvenementResponse.documentId;
        this.titre = apiEvenementResponse.type_d_atelier.titre;
        this.descriptionCourte = apiEvenementResponse.type_d_atelier.description_courte;
        this.descriptionLongue = apiEvenementResponse.type_d_atelier.description_longue;
        this.startDate = new Date(apiEvenementResponse.date_de_debut);
        this.endDate = new Date(apiEvenementResponse.date_de_fin);
        this.participantsMin = apiEvenementResponse.participantsMin;
        this.participantsMax = apiEvenementResponse.participantsMax;
        this.participants = apiEvenementResponse.participants;
        this.gallery = apiEvenementResponse.type_d_atelier.gallery;
        this.themes = apiEvenementResponse.type_d_atelier.themes;
        this.couleur = apiEvenementResponse.type_d_atelier.type_de_prestation.couleur;
        this.lieu = apiEvenementResponse.lieu;
    }

    /**
     * La taux de remplissage de l'évenement
     * @returns un nombre entre 0 et 1
     */
    get participantsCompletion(): number {
        return this.participantsMin / this.participantsMax;
    };


    // get trancheAge(): string {
    //     return `${this.ageMin}/${this.ageMax} ans`
    // }

    /**
     * return la durée de l'evenement en jours
     */
    get duration(): number {
        return this.endDate.getDay() - this.startDate.getDay()
    }

    get complet(): boolean {
        return this.participantsCompletion >= 1;
    }
}